import $ from 'jquery';
import L from 'leaflet';
import 'owl.carousel';

$(window).on('load resize', function() {

  let options;
  if($(window).width() > 680) {
    options = {
      center: [6.2518, -75.5636],
      zoom: 13, // Debe estar en 13 por defecto
      minZoom: 12, // Debe estar en 13 para evitar que desborde, 10 para pruebas
      maxZoom: 20,
    }
  } else {
    options = {
      center: [6.2518, -75.5636],
      zoom: 12,
      minZoom: 11,
      maxZoom: 16,
    }
  }

  let map = L.map('map', options);

  const imageBounds = [
		[5.982144, -75.752792], // Esquina sureste
		[6.533179, -75.195836]  // Esquina noroeste
  ];

  // Poner mapa personalizado
  var customOverlay = L.imageOverlay('/wp-content/themes/proyecto516/src/assets/images/map.svg', imageBounds).addTo(map);

  // Crear un rectángulo y agregarlo al mapa
  // var rectangle = L.rectangle(imageBounds, { color: 'red', weight: 2 }).addTo(map);

  // Forzar el mapa a estar dentro de los límites
  map.setMaxBounds(imageBounds);

  // L.tileLayer('https://tile.openstreetmap.org/{z}/{x}/{y}.png', {
  //   attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
  // }).addTo(map);

  // Ubicación actual
  if ("geolocation" in navigator) {
    navigator.geolocation.getCurrentPosition(onLocationFound);
  } else {
    alert("Geolocation is not supported by this browser.");
  }

  function onLocationFound(position) {
    let latitude = position.coords.latitude;
    let longitude = position.coords.longitude;

    let circle = L.circle([latitude, longitude], {
      color: 'red',
      fillColor: 'red',
      fillOpacity: 0.5,
      radius: 300
    }).addTo(map);

    map.panTo([latitude, longitude]);
  }

  if(mapData != null && mapData != undefined ) renderMarkers();

  function renderMarkers() {
    $.each(mapData, function(key, element) {
      if (element.ubicacion_latitud == '' || element.ubicacion_longitud == '' || typeof element.category == 'undefined' || element.category == '') return true;

      let content_type = element.tipo_de_contenido;
      let data;
      let tooltipContent = '';

      if(content_type == 'galeria') {
        data = element.gallery;
        tooltipContent = `
        <div class="tooltip-content">
          <div class="title"><img src="${ element.icon.url }"><p>${ element.post_title }</p></div>
          <div class="banner"><img src="${ element.banner }"></div>
          ${ element.post_content }
          <div class="type-icon image-gallery"><i class="fa-solid fa-image"></i></div>
        </div>`;
      } else {
        data = element.enlace;
        let poster = element.poster;
        tooltipContent = `
        <div class="tooltip-content">
          <div class="title"><img src="${ element.icon.url }"><p>${ element.post_title }</p></div>
          <div class="banner"><img src="${ element.banner }"></div>
          ${ element.post_content }
          <div class="type-icon video-player"><i class="fa-solid fa-video"></i></div>
        </div>`;
      }

      let class_name = element.category.slug;
      let icon = L.icon({
        iconUrl: element.icon.url,
        className: class_name,
        iconSize: [48, 48],
        iconAnchor: [24, 48]
      });

      let popupOptions = {
        keepInView: true,
      }

      setTimeout(() => {
        L.marker([element.ubicacion_latitud, element.ubicacion_longitud], {icon: icon}).bindPopup(tooltipContent, popupOptions).addTo(map).on('click', () => { markerClick(content_type, data, element.post_title, element.icon.url) });
      }, 200);
    });
  }

  function markerClick(type, data, title, icon) {
    if(type == 'galeria') {
      let carouselHTML = `
        <div class="close-btn"></div>
        <div class="close-overlay"></div>
        <div class="modal-content">
          <div class="title"><img src="${icon}"><p>${title}</p></div>
          <div class="gallery owl-carousel owl-theme">

          </div>
        </div>`;
      $('.popup-modal').html(carouselHTML);

      let images = '';
      for(let i = 0; i < data.length; i++) {
        images += `
        <div class="item">
          <img src="${data[i]}" alt="">
        </div>`;
      }
      $('.popup-modal .gallery').html(images);
      $('.popup-modal .gallery').owlCarousel({
        items: 1,
        loop: true,
        dots: true,
        nav: false,
        margin: 20,
      });

      $('.leaflet-popup-content .image-gallery').on('click', function() {
        $('html').addClass('scroll-none');
        $('.popup-modal').addClass('active');
      });

      $('.popup-modal .close-btn, .popup-modal .close-overlay').on('click', function() {
        $('html').removeClass('scroll-none');
        $('.popup-modal').removeClass('active');
        $('.popup-modal .gallery').trigger('to.owl.carousel', 0);
      });
    }

    if(type == 'video') {
      let videoHTML = `
        <div class="close-btn"></div>
        <div class="close-overlay"></div>
        <div class="modal-content video">
          <div class="title"><img src="${icon}"><p>${title}</p></div>
          <div class="video-container">
            ${data}
          </div>
        </div>`;

      $(document).on('click', '.leaflet-popup-content .video-player', function() {
        $('html').addClass('scroll-none');
        $('.popup-modal').addClass('active');
        $('.popup-modal').html(videoHTML);

        $(document).on('click', '.popup-modal .close-btn, .popup-modal .close-overlay', function() {
          $('.popup-modal').removeClass('active');
          $('html').removeClass('scroll-none');
          $('.popup-modal').html('');
        });
      });

    }
  }

  $('.filters input').on('change', function() {
    $(this).parents('.item').toggleClass('active');
    let selected = [];

    $('.filters input').each(function() {
      if($(this).is(':checked')) {
        selected.push($(this).val());
      }
    })

    if(!selected.length) {
      $('.leaflet-marker-pane img').show();
      return;
    }

    $('.leaflet-marker-pane img').hide();

    $('.leaflet-marker-pane img').each(function(i, e) {
      selected.forEach((cat) => {
        if($(e).hasClass(cat)) {
          $(e).show();
        }
      })
    });
  });

  $(document).on('click', function(event) {
    if(!$(event.target).closest('.mobile-filters, .filters-trigger').length) {
      if($('.mobile-filters').hasClass('active')) {
        $('.mobile-filters').removeClass('active')
      }
    }
  });

  $('header .filters-trigger').on('click', function() {
    $('html').toggleClass('scroll-none');
    $(this).toggleClass('active');
    $('.mobile-filters').toggleClass('active');
  });

  if(localStorage.getItem('atv-popup') !== 'true') {
    $('.start-popup').addClass('active');
    $('header .filters-trigger').css('pointer-events', 'none');
  } else {
    $('#map').addClass('active');
  }

  $('.start-popup .cta-btn').on('click', function(e) {
    e.preventDefault;

    $('#map').addClass('active');
    $(this).parents('.start-popup').removeClass('active');
    $('header .filters-trigger').css('pointer-events', 'auto');
    localStorage.setItem('atv-popup', 'true');
  });

  // Coordenadas en la consola al dar clic en ubicación del mapa
  map.on('click', function(e) {
    let coord = e.latlng.toString().split(',');
    let lat = coord[0].split('(');
    let lng = coord[1].split(')');
    console.log("You clicked the map at latitude: " + lat[1] + " and longitude:" + lng[0]);
  });

});